module.exports = __webpack_public_path__ + "static/media/risaa.2991c786.png";